import { useThemeManager as useThemeManagerFromContext } from "providers/ThemeProvider";

// Re-export the hook from the provider to maintain backward compatibility
export const useThemeManager = useThemeManagerFromContext;
